import React from 'react';
import { Modal, List, Typography } from 'antd';
import { type OrderOperationLogItem } from '../../../../types/process/order-record';

const { Text } = Typography;

interface OperationLogModalProps {
  visible: boolean;
  onClose: () => void;
  logs?: OrderOperationLogItem[];
}

export const OperationLogModal: React.FC<OperationLogModalProps> = ({ visible, onClose, logs }) => {
  return (
    <Modal
      title="标记记录"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <List
        dataSource={logs || []}
        renderItem={(item) => (
          <List.Item style={{ display: 'block', padding: '16px', marginBottom: '8px', background: '#f5f5f5', borderRadius: '4px', border: 'none' }}>
            <div style={{ marginBottom: '8px', fontSize: '14px', color: '#333' }}>
              {item.remark}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#999', fontSize: '12px' }}>
              <span>{item.remark_by}</span>
              <span>{item.created_at}</span>
            </div>
          </List.Item>
        )}
        split={false}
        style={{ maxHeight: '60vh', overflowY: 'auto' }}
      />
    </Modal>
  );
};
